import { format, isValid, parse, parseISO } from "date-fns";

/**
 * @param {number | string} amount
 * @returns {string}
 */
export const formatMoney = (amount) => {
  if (!Number.isFinite(Number(amount))) {
    return "-";
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(Number(amount));
};

/**
 * @returns {{ year: number, month: number } | null}
 */
export const monthAbbrevAndYearToCalendarMonth = (abbrev, year) => {
  const d = parse(`${abbrev} ${year}`, "MMM yyyy", new Date());
  return isValid(d) && { year: d.getFullYear(), month: d.getMonth() + 1 };
};

export const formatDisplayDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  return isValid(d) ? format(d, "MM/dd/yyyy") : String(value);
};
